export function formatAmount(valor) {
  return new Intl.NumberFormat('es-ES', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(valor);
}

const categoryLabels = {
  bienestar: 'Bienestar',
  deportes: 'Deportes',
  gastro: 'Gastro',
  ocio: 'Ocio',
  viajes: 'Viajes',
  regalos: 'Regalos'
};

export function getCategoryLabel(category) {
  return categoryLabels[category] || category;
}

const subcategoryLabels = {
  dentista: 'Dentista',
  estetica: 'Estética',
  'masajes-fisioterapia': 'Masajes y fisioterapia',
  medicina: 'Medicina',
  'mindfulness-relax': 'Mindfulness',
  nutricionista: 'Nutrición',
  peluqueria: 'Peluquería',
  psicologia: 'Psicología',
  'spa-balneario': 'Spas y balnearios',
  tattoos: 'Tattoos',
  'clases-de-baile': 'Clases de baile',
  'natacion-aquagym-piscina': 'Deportes acuáticos',
  'deportes-de-equipo': 'Deportes de equipo',
  'fitness-gym': 'Deportes de gym',
  'esqui-raquetas-quad-buggy-deportes-invierno': 'Deportes de invierno',
  'boxeo-taekwondo-lucha': 'Deportes de lucha',
  'barranquismo-parapente-ferratas-montana': 'Deportes de montaña',
  'karts-paratrike-motor': 'Deportes de motor',
  'deportes-de-raqueta': 'Deportes de raqueta',
  'deportes-individuales': 'Deportes individuales',
  asiatica: 'Asiática',
  'cursos-talleres-catas': 'Cursos, talleres y catas',
  'desayunos-dulces-brunch': 'Dulces, desayunos y brunch',
  americana: 'Hamburguesas y bocadillos',
  healthy: 'Healthy',
  internacional: 'Internacional',
  mediterranea: 'Mediterránea',
  italiana: 'Pizza y pasta',
  'vegetariana-y-vegana': 'Vegetariana y vegana',
  'cine-teatro': 'Cine y teatro',
  'conocer-gente': 'Conocer gente',
  'cursos-talleres-pintura-ceramica': 'Cursos y talleres',
  'escape-room-ocio-alternativo': 'Escape room y ocio alternativo',
  fotografia: 'Fotografía',
  'juegos-rol-mesa-videojuegos': 'Juegos de mesa y videojuegos',
  'museos-exposiciones': 'Museos y exposiciones',
  'nocturno-musica': 'Música y ocio nocturno',
  'practicar-idiomas': 'Practicar idiomas',
  autocaravana: 'Autocaravana',
  camper: 'Camper',
  'casas-rurales-hoteles': 'Casas rurales y hoteles',
  'en-grupo': 'En grupo',
  'en-pareja': 'En pareja',
  excursiones: 'Excursiones',
  'playa-montana': 'Playa y montaña',
  'tarjetas-regalo': 'Tarjetas de regalo'
};

export function getSubcategoryLabel(subcategory) {
  return subcategoryLabels[subcategory] || subcategory;
}
